export const CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'common',
});
